import React, { createContext, useState } from 'react'
import PropTypes from 'prop-types'
import usePartner from '../../hooks/usePartner'
import useSSO from '../../hooks/useSSO'

export const initialContext = {
  env: 'prod',
  isUnlocked: false,
}

export const CUGContext = createContext(initialContext)

function CUGProvider({ env, children, isCugUnlocked }) {
  const cugConfig = usePartner('config.cug')
  const validationType = cugConfig?.validationType
  const { isSignedIn } = useSSO() || {}
  const [isUnlocked, setIsUnlocked] = useState(
    isCugUnlocked || validationType === 'auth' || (validationType === 'sso' && isSignedIn)
  )

  const props = {
    env,
    ...cugConfig,
    isUnlocked,
    handleUnlock: (callback) => {
      setIsUnlocked(true)
      typeof callback === 'function' && callback()
    },
  }

  return <CUGContext.Provider value={props}>{children}</CUGContext.Provider>
}

CUGProvider.displayName = 'CUGProvider'

CUGProvider.propTypes = {
  children: PropTypes.node,
  isCugUnlocked: PropTypes.bool,
  env: PropTypes.string,
}

export default CUGProvider
